import { render, staticRenderFns } from "./preview-attachment-action.vue?vue&type=template&id=681bc219"
import script from "./preview-attachment-action.ts?vue&type=script&lang=js&external"
export * from "./preview-attachment-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports